import { IActor, IStoryData } from 'redhotpie-shared-lib/interfaces/INewFeed';
import * as utils from '../functions/utils';
import owner from './owner';
import { IContentItem } from 'redhotpie-shared-lib/interfaces/ICommunity';

export default class Forum {
  id: number | undefined;
  parrentType: string;
  title: string;
  description: string;
  likeCount: number;
  replyCount: number;
  isMemberLike: boolean;
  dateCreated: number | string | undefined;
  owner: IActor;
  seoURL?: string;

  constructor() {
    this.id = undefined;
    this.parrentType = '';
    this.title = '';
    this.description = '';
    this.likeCount = 0;
    this.replyCount = 0;
    this.isMemberLike = false;
    this.dateCreated = '';
    this.owner = {};
    this.seoURL = '';
  }

  static mappingObject(_obj: IStoryData): IContentItem {
    let obj = Object.assign(new Forum(), _obj);
    obj.id = _obj.ID || -1;
    obj.parrentType = _obj.ParentType ? _obj.ParentType : '';
    obj.title = _obj.Title ? _obj.Title : '';
    obj.description = _obj.Description ? _obj.Description : '';
    obj.likeCount = _obj.LikeCount || 0;
    obj.replyCount = _obj.ReplyCount || 0;
    obj.isMemberLike = _obj.IsMemberLike ? _obj.IsMemberLike : false;
    obj.owner = _obj.Owner ? owner.mappingObject(_obj.Owner) : {};
    obj.dateCreated = _obj.DateCreated ? _obj.DateCreated : '';
    obj.seoURL = _obj.SEOUrl || '';
    obj = utils.cleanObjectKeys(Object.keys(new Forum()), obj);

    return obj;
  }

  static mappingObjects(_data: IStoryData[]): IContentItem[] {
    return _data.map(item => Forum.mappingObject(item));
  }
}
